import React, { forwardRef, HTMLProps, RefForwardingComponent, useEffect } from 'react';

import useTheme from '@gojob/ui-bits/styles/useTheme';

import useQueryJobByIndex from 'src/components/InfiniteJobList/useQueryJobByIndex';
import JobPreview from 'src/components/JobPreview';
import createPath from 'src/utils/create-path';

export interface LiveJobPreviewProps extends HTMLProps<HTMLDivElement> {
  loading?: boolean;
  index?: number;
  query?: string;
  lat?: number;
  lng?: number;
  radius?: number;
  onDisplayChanged?: () => void;
}

const useStyles = () => {
  const { breakpoint } = useTheme();

  return {
    preview: {
      width: '100%',
      maxWidth: breakpoint.values.md,
    },
  } as const;
};

const LiveJobPreview: RefForwardingComponent<HTMLDivElement, LiveJobPreviewProps> = (props, ref) => {
  const { index, onDisplayChanged, query, lat, lng, radius, loading: parentLoading, ...other } = props;

  const classes = useStyles();

  const { job = {}, error, loading } = useQueryJobByIndex(index, query, lat, lng, radius, {
    skip: parentLoading,
  });

  useEffect(() => onDisplayChanged?.(), [loading, parentLoading]);

  const { shortId, caption, city } = job;
  const to = createPath({ city, caption, shortId, type: 'job-offer' });

  return (
    <div ref={ref} {...other}>
      <JobPreview
        error={!!error}
        css={classes.preview}
        to={to}
        loading={parentLoading || loading}
        id={job.id}
        position={index}
        caption={job?.caption}
        city={job?.city}
        postalCode={job?.postalCode}
        weeklyHours={job?.weeklyHours}
        salary={job?.salary}
      />
    </div>
  );
};

export default forwardRef(LiveJobPreview);
